import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z"
            fill="white"
        />
        <path
            d="M8.36346 22.3625V21.2177L7.07094 21.1254V10.6744L23.8552 8.31098V22.344L13.5151 21.6054L10.7269 23.1934V21.4208L9.52672 21.3285V25.1691L13.7551 22.7872L25 23.6365V7L6 9.69582V22.1778L8.36346 22.3625Z"
            fill="url(#paint0_linear_15_11)"
        />
        <path
            d="M11.7609 17.0447C12.2912 17.0447 12.7211 16.6148 12.7211 16.0846C12.7211 15.5543 12.2912 15.1244 11.7609 15.1244C11.2306 15.1244 10.8008 15.5543 10.8008 16.0846C10.8008 16.6148 11.2306 17.0447 11.7609 17.0447Z"
            fill="url(#paint1_linear_15_11)"
        />
        <path
            d="M15.4908 17.0447C16.021 17.0447 16.4509 16.6148 16.4509 16.0846C16.4509 15.5543 16.021 15.1244 15.4908 15.1244C14.9605 15.1244 14.5306 15.5543 14.5306 16.0846C14.5306 16.6148 14.9605 17.0447 15.4908 17.0447Z"
            fill="url(#paint2_linear_15_11)"
        />
        <path
            d="M19.2206 17.0447C19.7509 17.0447 20.1808 16.6148 20.1808 16.0846C20.1808 15.5543 19.7509 15.1244 19.2206 15.1244C18.6903 15.1244 18.2605 15.5543 18.2605 16.0846C18.2605 16.6148 18.6903 17.0447 19.2206 17.0447Z"
            fill="url(#paint3_linear_15_11)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_15_11"
                x1={6}
                y1={9.62196}
                x2={25.0185}
                y2={23.6181}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00AEEF" />
                <stop offset={1} stopColor="#0097DA" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_15_11"
                x1={6.07385}
                y1={9.75122}
                x2={24.0583}
                y2={23.7104}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_15_11"
                x1={9.80369}
                y1={9.75122}
                x2={27.7881}
                y2={23.7104}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_15_11"
                x1={13.5335}
                y1={9.75122}
                x2={31.518}
                y2={23.7104}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
        </defs>
    </svg>
);
export default SVGComponent;
